import React from 'react'

export const Tag = ({ text, deleteItem, dataId }) => (
  <div className="item-tag" data-id={dataId}>
    <div className="text">{text}</div>
    <span className="fas fa-times icon" onClick={deleteItem} />
  </div>
)
export const Item = ({ selectItem, text, used }) => (
  <div className={`item ${used && 'used'}`} onClick={selectItem}>
    {used && <i className="fas fa-check"></i>}
    <div className="text">{text}</div>
  </div>
)
